export const ACCEPTED_FILE_EXTENSIONS = ['.pdf'] as const;

export const ACCEPTED_MIME_TYPES = ['application/pdf'] as const;
